import { render, staticRenderFns } from "./IcoJigsaw.vue?vue&type=template&id=0e1fa392"
import script from "./IcoJigsaw.vue?vue&type=script&lang=js"
export * from "./IcoJigsaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports